import * as THREE from 'three';
import Experience from './Experience.js';

export default class Renderer {
    constructor() {
        this.experience = new Experience();
        this.canvas = this.experience.canvas;
        this.sizes = this.experience.sizes;
        this.scene = this.experience.scene;
        this.camera = this.experience.camera;

        this.setInstance();
    }

    setInstance() {
        this.instance = new THREE.WebGLRenderer({
            canvas: this.canvas,
            antialias: false,
            preserveDrawingBuffer: true,
        });
        this.instance.outputColorSpace = THREE.SRGBColorSpace;
        // this.instance.physicallyCorrectLights = true
        // this.instance.toneMapping = THREE.CineonToneMapping
        // this.instance.toneMappingExposure = 1.75
        // this.instance.shadowMap.enabled = true
        // this.instance.shadowMap.type = THREE.PCFSoftShadowMap
        this.instance.setSize(this.sizes.width, this.sizes.height);
        this.instance.setPixelRatio(1);
        this.instance.setClearColor(0x000000, 1);
        this.instance.gammaOutput = true;
        this.instance.gammaFactor = 2.2;
        this.instance.outputColorSpace = THREE.SRGBColorSpace;
    }

    resize() {
        // this.instance.setSize(this.sizes.width, this.sizes.height);
        // this.instance.setPixelRatio(this.sizes.pixelRatio);
    }

    update() {
        this.instance.render(this.scene, this.camera.instance);
        
    }

    onScreenshotTaken(renderTargetPhoto) {
        this.instance.setRenderTarget(renderTargetPhoto)
        this.instance.clear()
        this.instance.render(this.scene, this.camera.instance, renderTargetPhoto )
    }

    onPreparePoster() {
        this.sizes.height = 1024
        this.sizes.width = 724

        this.camera.instance.aspect = this.sizes.width / this.sizes.height
        this.camera.instance.updateProjectionMatrix()

        this.instance.setSize(this.sizes.width, this.sizes.height)
        this.instance.setPixelRatio(this.sizes.pixelRatio)
    
    }

    onDownloadImage(renderTargetPoster, posterSize, canvas) {
        this.instance.render(this.scene, this.camera.instance)
        this.instance.setRenderTarget(renderTargetPoster)
        this.instance.clear()
        this.instance.render(this.scene, this.camera.instance, renderTargetPoster )
        return canvas.toDataURL("image/jpeg", 0.5);
    
        // canvas.style.display = 'none'
    }

    destroy() {
        this.instance.dispose();
    }
}